<template lang="html">
  <section 
    class="position-relative" 
    id="main-search"
    :class="{'mobile-main-search': mobile, 'main-search': !mobile}"
    v-hotkey.prevent="keymap"> <!--TODO: update when pattern is mobile friendly-->
    <Tabs v-if="mobile && showMobileTabs" @set="showMobileTabs=false"></Tabs>
    <b-button
      v-if="mobile"
      id="hide-mobile-tabs"
      @click="showMobileTabs = false"
      class="d-none"
    />
    <b-button
      v-if="mobile"
      variant="background"
      @click="toggleMobileTabs"
      class="position-absolute mode-btn px-3 shadow-none"
    >{{selectedMode}}
      <i class="fas fa-caret-down"></i>
    </b-button>
    <div :class="{'search-input-wrap px-2 pt-1 pb-3 mb-3':!mobile && $route.name !== 'unvocalized'}">    
      <TypeAhead         
        @run-search="runCharuzit"
        @run-search-clicked="(w) => searchWord=w"        
        @clear-search="clearSearchTerm"
        @not-in-list="reset"
        @word-typed="(w) => $emit('word-typed', w)"
        :label="hebrew ? 'מילת חיפוש' : 'Search word'"
        :typeAheadFunc="getSoundPlayTypeAheads"
        :searchTerm="searchWord"                
        :forceHebrew = "true"
        :searchId = "'search-input-dd'"
        :customClass="mobile ? 'mobileSearchTypeAhead' : ''"
      />  
    </div>
    <div v-if="mobile && mode !== 'tavnit'" class="text-left mt-2"> <!--TODO: when mobile ready  && mode !== 'tavnit'-->
      <a 
        class="text-primary" 
        @click="showMobileSemantic=true">
        <i class="fas fa-plus-square"></i>
        חיפוש מתקדם <span v-if="semanticWordsLength>0">({{semanticWordsLength}})</span>
      </a>
      <MobileSemantic v-if="showMobileSemantic" v-model="showMobileSemantic" />
    </div>  
  </section>
</template>

<script>  
  import TypeAhead from '@/components/TypeAhead'
  import {Actions} from '@/store/stateChanges'
  import Tabs from '@/components/tabs'
  import MobileSemantic from '@/components/mobileSemanticModal'
  import axios from 'axios'
  import {StoreConfig} from '@/store/storeConfig'

  const SOUNDPLAY_SERVER = StoreConfig.SOUNDPLAY_SERVER
  axios.defaults.headers = {
    'Content-Type': 'application/json'
  }
  const axiosInstance = axios.create({timeout: 130000})

export default  {
    name: 'MainSearch',
    components: {
      TypeAhead,
      Tabs,
      MobileSemantic
    },   
    data() {
      return {     
        openSearch: false,
        searchType: 'rhyme',
        showMobileTabs: false,
        showMobileSemantic: false
      }
    },
    mounted () { 
       
    },
    methods: {
      hasNikud (wrd) {
        return wrd.trim().length > wrd.trim().replace(/[^א-ת]/g, '').length
      },
      toggleMobileTabs () {
        this.showMobileTabs = !this.showMobileTabs
        if (this.showMobileTabs)
           history.pushState('', document.title, window.location.pathname + window.location.search)
      },
      reset () {
        //this.$store.commit('CLEAR_RESULTS')
      },
      clearSearchTerm () {
        this.$store.commit('SET_TEXT_FOR_CHARUZIT_API_CALL', '')       
      },
      getSoundPlayTypeAheads : async function (wordSoFar) {
        const result = await axiosInstance.post(
          SOUNDPLAY_SERVER, JSON.stringify({
            w: wordSoFar
          })
        )
        return result.data
      },   
      runCharuzit (txt) {   
        this.$store.commit('SET_TEXT_FOR_CHARUZIT_API_CALL', txt)
        if (this.mode !== 'tavnit') {
          this.$store.dispatch(Actions.RUN_CHARUZIT)         
        }
        this.$emit('word-selected')
      }             
    },
    computed: {
      keymap () {
        return {
          'backspace': () => {
            let inputValue = document.getElementById('search-input-dd').value
            if (this.hasNikud(inputValue)) {
              let lastChar = inputValue[inputValue.length-1]
              if (this.hasNikud(lastChar)) {
                document.getElementById('search-input-dd').value = inputValue.slice(0, -1)
              }
            }
          },
          'F9': () => {
            document.getElementById('search-input-dd').focus()
          }
        }
      },
      selectedMode() {
        var selectedMode = ''  
        switch (this.mode) {
          case 'alliteration':
            selectedMode = 'אליטרציה'
            break;
          case 'tavnit':
            selectedMode = 'תבנית מילה'
            break;
          case 'xxsonance':
            selectedMode = 'מצלול'
            break;         
          default:
            selectedMode = 'rhyme'
            selectedMode = 'חרוזים'
            break;
         
        }
        return selectedMode  
      },
      mode () {
        return this.$store.state.searchModel
      },

      searchWord: {
        get () {
          return this.$store.state.textForCharuzitApiCall
        },
        set (value) {
          this.$store.commit("SET_TEXT_FOR_CHARUZIT_TEMP_API_CALL", value)          
        }
      },  
      mobile () {
        return this.$mq === 'xs'
      },                 
      hebrew () {
        return this.$settings.hebrew
      },    
      nakdanList () {
        return this.$store.state.soundplayResults.error == null ? this.$store.state.soundplayResults : ''
      },
      semanticWordsLength () {
        return this.$store.state.semanticKeywordsArr.length
      },
      runState () {
        return this.$store.state.charuzitApiState
      },
    },
    watch : {
      runState (val) {
        if (val === 'Complete') {               
          if (!this.mobile) {
            this.$nextTick(function () { 
              document.getElementById('search-input-dd').focus()
            })
          }
        }
      }  
    }
}
</script>

<style lang="scss" scoped>
  .main-search {
    background-color: #bfe1fe;
    border-radius: 4px;
    margin-top: 40px;
  }

 .mobile-main-search {
    padding: 12px 15px;
    margin: 0 -15px!important;
    background-color: #bfe1fe;
    .mode-btn {
      border-radius: 6px 0 0 6px;
      left: 15px;
      top: 12px;
      height: 48px;
      z-index: 2;
      font-size: 16px;
    }
  }
</style>
<style lang="scss">
 .mobileSearchTypeAhead {
   label {display: none!important;}
 }
</style>